import { StaffMessages } from '../translations-types';

const translations: StaffMessages = {
  title: 'Messages',
  markRead: 'Mark as read',
  noMessages: 'No messages',
  completedQuestionnaire: 'completed:',
  sentBy: 'Sent by',
};

export default translations;
